import { httpRequest } from './Server/Axios';

export const LoginTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/bakeryPreBooking/login`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const insertTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/insertTask`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const getPendingQualifiedTasksAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/pendingQualifiedTasks`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const qualifyTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/qualifyTask`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const deleteTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/deleteTask`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const searchTaskCustomerAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/searchTaskCustomer`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const pendingTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/mypendingtask`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const acceptTaskAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/acceptmytask`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const insertTaskActivityAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/insertTaskActivity`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const getTaskActivityAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskActivity`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const supervisingTasksAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SupervisingTasks`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const pendingTaskSummaryAssigneeAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/pendingSummaryAssignee`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const pendingTaskSummarySupervisorAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/PendingTaskSummarySupervisor`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskStatisticsAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskStatistics`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskReminderAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskReminder`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const todayActivityAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/today-activity`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const todayNotificationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/task-notification`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const updateTaskReadStatusAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/update-task-read-status`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const salesLeadSummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SalesLeadSummary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const updateSalesLeadAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateSalesLead`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const attributesAPI = async (apiObj) => {
  let apiMethod = {
    method: 'GET',
    url: `/task/fAttributes`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const insertSalesLeadMeetingAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/insertSalesLeadMeeting`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const salesLeadMeetingAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/salesleadmeeting`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskLeadQuotationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskLeadQuotation`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskLeadQuotationUpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskLeadQuotationUpdate`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskActivityQualifyAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskActivityQualify`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskActivityValidationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskActivityValidation`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const getClosedTasksByDateRangeAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/getClosedTasksByDateRange`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const activityHeatMapAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/activityHeatMap`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskClientVisitSummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/taskClientVisitSummary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const createTaskClientVisitAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/createUpdateTaskClientVisit`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const updateTaskClientVisitCompleteAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateTaskClientVisit`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const amcSummaryDataAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/amc/amcSummaryData`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const AMCStatusNarr_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/AMCStatusNarr_Update_001`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const generateInvoiceAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/amc/generateInvoice`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const sendEmailAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/amc/send-email`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskCompanyInsertAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskCompanyInsert`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const taskLeadCompanyAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskLeadCompany`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const updateSalesLeadConfirmationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateSalesLeadConfirmation`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const taskSalesLeadStatusAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskSalesLeadStatus`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const salesLeadConfirmationPDFAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SalesLeadConfirmationPDF`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const getSalesLeadConfirmationPDFAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/getSalesLeadConfirmationPDF`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const updateSalesLeadPaymentAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateSalesLeadPaymentDocPDF`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const getSalesLeadPaymentDocPDFAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/getSalesLeadPaymentDocPDF`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const getTaskLeadInstallationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/getTaskLeadInstallation`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const updateTaskLeadInstallationAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateTaskLeadInstallation`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const updateTaskSalesLeadStageAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/updateTaskSalesLeadStage`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const getModuleQuickLaunchDataAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/getModuleQuickLaunchData`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const SWUpdateMaster_SummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'GET',
    url: `/task/SWUpdateMaster_Summary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateMaster_GetRowAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateMaster_GetRow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateMaster_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateMaster_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateMaster_DeleteAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateMaster_Delete`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateTransHead_SummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransHead_Summary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateTransDetail_GetRowAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransDetail_GetRow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateTransDetail_Steps_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransDetail_Steps_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateTransHead_Status_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransHead_Status_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateTrans_Head_Detail_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTrans_Head_Detail_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateContact_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateContact_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const SWUpdateContact_GetrowAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateContact_Getrow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const SWUpdate_Customer_SearchAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransHead_Customer_Search`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const SWUpdateTransHead_Start_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/SWUpdateTransHead_Start_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const softwareAttributesAPI = async (apiObj) => {
  let apiMethod = {
    method: 'GET',
    url: `/task/SoftwareUpdateAttributes`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const reasonAttributesAPI = async (apiObj) => {
  let apiMethod = {
    method: 'GET',
    url: `/task/IsLostReasonAttributes`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskSalesLead_Lost_updateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskSalesLead_Lost_update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const AMCStatusNarr_GetRowAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/AMCStatusNarr_GetRow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseBooking_SUMMARYAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_SUMMARY`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseBooking_DeleteAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Delete`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const AccontsTransSearchAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/AccontsTransSearch`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseType_GetrowAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseType_Getrow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseBooking_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseBooking_Image_GetAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Image_Get`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Verified_SummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Verified_Summary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Verify_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Verify_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Status_ReverseAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Status_Reverse`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Confirm_SummaryAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Confirm_Summary`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Confirm_UpdateAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Confirm_Update`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskExpenseBooking_Confirm_Status_ReverseAPI = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseBooking_Confirm_Status_Reverse`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const TaskSalesLead_Statistic_API = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskSalesLead_Statistic_Getrow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const AMCDetail_DASH_Statistic_API = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/AMCDetail_DASH_Statistic_GetRow`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};

export const TaskExpenseType_API = async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/TaskExpenseType`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};
export const Task_ReportApi= async (apiObj) => {
  let apiMethod = {
    method: 'POST',
    url: `/task/My_Pending_Task_Report`,
    data: apiObj
  };
  var Data = await httpRequest(apiMethod);

  return Data;
};